import { InferType, object, string } from 'yup';

export const CareDocumentResourceSchema = object().shape({
  type: string().required(),
  name: string().required(),
  link: string().required(),
});

export type CareDocumentResource = InferType<typeof CareDocumentResourceSchema>;
